import React, { useState, useEffect, useContext } from "react";
import Joyride from "react-joyride";
import { getGlobalState } from "../utils/globalState";
import { setNewLeftNav } from "../utils/api";

const steps = [
    {
        target: ".AllDashboards",
        content: "Search for dashboards here. Drag and Drop or right-click to add to your dashboards."
    },
    {
        target: ".MyDashboards",
        content: "Your dashboards are stored here. Create and remove folders by right-clicking."
    },
];

const NewUserTour = () => {
    const [run, setRun] = useState(false);
    const { isNewLeftNav } = getGlobalState();

    useEffect(() => {
        if (isNewLeftNav === 1) {
            setRun(true);
        }
    }, [isNewLeftNav]);

    const handleJoyrideCallback = async (data) => {
        const { status } = data;
        if (["finished", "skipped"].includes(status)) {
            setRun(false);
            await setNewLeftNav();
        }
    };

    return (
        <Joyride
          steps={steps}
          run={run}
          continuous
          showSkipButton
          showProgress
          callback={handleJoyrideCallback}
          styles={{
            options: {
              primaryColor: "#1976d2", // Change button and beacon color
              zIndex: 10000,
            },
            beacon: {
              inner: "#1976d2", // Beacon color
              outer: "#90caf9",
            },
          }}
        />
    );
};

export default NewUserTour;